webpackJsonp([110940295940287],{

/***/ "./node_modules/json-loader/index.js!./.cache/json/shop-merino-pom-pom-beanie.json":
/***/ (function(module, exports) {

	module.exports = {
		"pathContext": {
			"path": "/shop/merino-pom-pom-beanie/"
		}
	};

/***/ })

});


// WEBPACK FOOTER //
// path---shop-merino-pom-pom-beanie-300dec76c971d752cbcf.js